import app from '../firebase';

import {
    getFirestore,
    doc,
    getDoc,
} from 'firebase/firestore';

import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

// components
import Customer from '../components/services/customer';
import Seller   from '../components/services/seller';

export default function Product() {

    const { serviceId } = useParams();

    const [service, setService] = useState();

    const getProduct = () => {
        getDoc(doc(getFirestore(app), 'services', serviceId))
            .then(result => setService([result.id, result.data()]));
    }

    useEffect(() => {
        getProduct();
    });

    return service && service[1].seller === localStorage.getItem('userId') ? <Seller /> : <Customer />
}